import fetch from 'unfetch';
import {polyfill} from 'es6-promise'; // for ie11

polyfill();

const isDangerouRequest = req => req.indexOf('<title>A potentially dangerous Request') > -1;

const getErrorWithField = (r, form) => {
	if (form && form.action.indexOf('api/job') > -1) {
		const result = r.match(/<title>.*?(\((.*?)=).*?<\/title>/);
		const field = result && result[2];

		if (field === 'Content') {
			return 'Using HTML tags are not allowed. Please remove them from the "Job description" field';
		}
		if (field === 'HowToApply') {
			return 'Using HTML tags are not allowed. Please remove them from the "How to apply" field';
		}
	}

	return 'Using HTML tags are not allowed. Please remove them from the form';
};

export default form => {
	const requireFormData = new FormData(form);
	const messageForm = form.querySelector('.form__message');
	const grecaptchaEl = form.querySelector('.g-recaptcha');
	const removeSpinner = () => {
		if (form.classList.contains('js-form-confirm')) {
			document.body.classList.remove('spinner');
		} else {
			form.parentNode.classList.remove('spinner');
		}
	};

	if (form.classList.contains('js-form-confirm')) {
		document.body.classList.add('spinner');
	} else {
		form.parentNode.classList.add('spinner');
	}
	let response = null;

	fetch(form.action, {
		method: 'POST',
		credentials: 'include',
		body: requireFormData
	})
		.then(res => {
			response = {...res};

			return res.status === 403
				? {success: true, redirect: '/login?returnUrl=' + encodeURIComponent(document.location.pathname + document.location.search)}
				: res.json();
		})
		.then(data => {
			if (data.success && data.redirect) {
				removeSpinner(form);
				window.location.href = data.redirect;
			} else if (data.success) {
				removeSpinner(form);
				form.parentNode.innerHTML = `<div class="form__text">${data.message}</div>`;
			} else {
				if (grecaptchaEl !== undefined && window.grecaptcha !== undefined) {
					window.grecaptcha.reset();
				}
				form.parentNode.classList.remove('spinner');
				messageForm.innerHTML = `<span class="form__error">${data.message}</span>`;
				messageForm.scrollIntoView({block: 'center', behavior: 'smooth'});
			}
		})
		.catch(data => {
			let message = '';

			response.text().then(r => {
				message = isDangerouRequest(r) ? getErrorWithField(r, form) : data.message;
				removeSpinner(form);
				messageForm.innerHTML = `<span class="form__error">${message}</span>`;
				messageForm.scrollIntoView({block: 'center', behavior: 'smooth'});
			});
		});
};

